import * as S from "./InfoItemData.style";
import { showAlert } from "@/components/containers/Alert";
import CopyToClipboard from "react-copy-to-clipboard";

interface InfoItemDataProps {
  data: any;
}

export const InfoItemData = ({ data }: InfoItemDataProps) => {
  return (
    <S.InfoItemData>
      <S.InfoLabel>{data.name}</S.InfoLabel>
      <S.InfoDataBox>
        {data.name === "UID" ? (
          <CopyToClipboard text={data.data}>
            <span onClick={() => showAlert("UID가 복사되었습니다.")}>
              {data.data}
            </span>
          </CopyToClipboard>
        ) : (
          data.data
        )}
      </S.InfoDataBox>
    </S.InfoItemData>
  );
};
